// src/openapi/utils.ts
import { fetchAuthSession } from '@aws-amplify/auth'
import createClient from 'openapi-fetch'
import type { paths as ALTAIR_PATHS } from './weapps/altair2'
import type { paths as VEGA_PATHS } from './weapps/vega'
import type { paths as CANOPUS_PATHS } from './weapps/canopus'

//docs
//https://openapi-ts.dev/introduction

const ALTAIR_API_BASE_URL = 'https://altair2.api.weapps.net'
const VEGA_API_BASE_URL = 'https://vega.api.weapps.net'
const CANOPUS_API_BASE_URL = 'https://canopus.api.weapps.net'

export class WeappsServices {

    static async altair() {
        const token = await this.getIdToken();

        const client = createClient<ALTAIR_PATHS>({
            baseUrl: ALTAIR_API_BASE_URL,
            headers: token?{Authorization: `Bearer ${token}`}:undefined
        });

        return client;
    }

    static async vega() {
        const token = await this.getIdToken();

        const client = createClient<VEGA_PATHS>({
            baseUrl: VEGA_API_BASE_URL,
            headers: token?{Authorization: `Bearer ${token}`}:undefined
        });
        return client;
    }

    static async canopus() {
        const token = await this.getIdToken();

        const client = createClient<CANOPUS_PATHS>({
            baseUrl: CANOPUS_API_BASE_URL,
            headers: token?{Authorization: `Bearer ${token}`}:undefined
        });
        return client;
    }

    private static async getIdToken(): Promise<string|undefined> {
        const session = await fetchAuthSession();
        return session.tokens?.idToken?.toString() || undefined;
    }
}
